<template>
    <div class="my-3">
        <ValidationObserver v-slot="{ invalid }" ref="observer">
             <b-form role="form">
                <b-row>
                    <b-col cols="8">
                        <b-form-group label="Tax Deduction">
                            <b-form-input
                            v-model="tax_deduction"
                            type="number"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="8">
                        <b-form-group label="Other Deduction">
                            <b-form-input
                            v-model="totalDeductions"
                            type="text"
                            disabled
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <el-table :data="deductions" style="width: 100%" cell-class-name="px-3">
                    <el-table-column label="No." width="50" align="center">
                        <template slot-scope="scope" >{{scope.$index + 1}}</template>
                    </el-table-column>
                    <el-table-column label="Code" width="200">
                        <template slot-scope="{row}">
                            <b-form-input v-model="row.code"></b-form-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="Description">
                        <template slot-scope="{row}">
                            <b-form-input v-model="row.description"></b-form-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="Amount(RM)">
                        <template slot-scope="{row}">
                            <CurrencyInput  :class="isUseNewInstallment(row) ? 'd-none' : ''"
                                v-model="row.amount"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
														<b-input-group :class="isUseNewInstallment(row) ? '' : 'd-none'">
															<template #append>
																<el-popover
																		placement="top-start"
																		trigger="hover">
																			<p>RM {{row.amount | moneyFormatter}} Has consolidate With New Instalment RM {{row.new_instalment | moneyFormatter}}</p>
																			<b-input-group-text slot="reference">
																				<strong  class="text-danger"><i class="el-icon-info"></i></strong>
																			</b-input-group-text>
																	</el-popover>
															</template>
															<CurrencyInput
																v-model="row.new_instalment"
																:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
																disabled
															/>
														</b-input-group>
                        </template>
                    </el-table-column>
                    <el-table-column label="Actions">
                        <template slot-scope="{row}">
                            <el-button 
                                @click.prevent="removeDeduction(row)" 
                                type="danger" 
                                icon="el-icon-close" 
                                size="mini" 
                                circle 
                            ></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <b-button @click="addDeduction" block variant="outline-primary" class="mt-3">+ Add</b-button>
            </b-form>
        </ValidationObserver>
    </div>
</template>

<script>
import { Button, Form, FormItem, Table, TableColumn, Select, Option, Popover } from 'element-ui'
import { ValidationObserver } from 'vee-validate';
import CurrencyInput from '@/components/CurrencyInput'
import '@/assets/js/formValidations.js'
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'

export default{
    props: ['customer'],
    components: {
				CurrencyInput,
        ValidationObserver,
        [Button.name]: Button,
        [Form.name]: Form,
        [FormItem.name]: FormItem,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Popover.name]: Popover,
    },
    data(){
        return{
            tax_deduction: this.customer.incomes.main.tax_deduction,
						deductions:[]
        }
    },
    computed:{
        totalDeductions(){
            const total = this.deductions.reduce((acc, rental) => {
                const amount = parseFloat(rental.amount);
                const newInstallment = parseFloat(rental.new_instalment);
                if (isNaN(amount)) {
                    return acc;
                }
								if(this.isUseNewInstallment(rental)){
									return acc + newInstallment;
								}else{
									return acc + amount;
								}
            }, 0);
            return parseFloat(total.toFixed(2));
        },
				isGovenment(){
					return this.customer.incomes.main.income_type_id === 3 || this.customer.incomes.main.income_type_id === 5
				}
    },
    created(){
			this.setFormOthDeduction();
      gEventBus.$on('collect-income-data', this.sendIncomeData);
    },
		beforeDestroy() {
      gEventBus.$off('collect-income-data', this.sendIncomeData);
    },
    methods: {
        isUseNewInstallment(item){
					return (this.isGovenment) ?  (item.is_consolidate == 1) : false;
				},
				setFormOthDeduction(){
					this.deductions = this.customer.incomes.other_tax_deduction;
				},
        setData(){
            let deductions = this.deductions.map((obj, index) => {
                return {
                    ...(obj.customer_tax_deduction_id && { customer_tax_deduction_id: obj.customer_tax_deduction_id }),
                    amount: obj.amount, 
                    description: obj.description, 
                    code: obj.code, 
                }
            })

            let data = { 
                deductions: deductions,
                tax_deduction: this.tax_deduction,
                total_other_deduction: this.totalDeductions
            }

            return data
        },
        removeDeduction(item) {
            if(this.deductions.length > 0){
                var index = this.deductions.indexOf(item);
                this.deductions.splice(index, 1);
            }
        },
        addDeduction() {
            this.deductions.push({
                customer_id: this.customer.customer_id,
                amount: null, 
                code: null, 
								is_consolidate: 0,
                description: null
            });
        },
        sendIncomeData(){
            this.$emit('income-data-collected', this.setData());
        }
    }
}
</script>
